import React, {PureComponent, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Immutable from 'immutable';
import cx from 'classnames';
import {Button, mapMessageStateToProps, getMessage} from 'epic-diesel-common';
import {Header, Footer} from '../../components';

import styles from './ErrorView.pcss';

const SUPPORTED_ERROR_CODES = [404, 500];

/**
 * Error view component
 */
const mapStateToProps = state => ({
    userState: state.get('user').toJS(),
    configState: state.get('config').toJS()
});

@connect(mapStateToProps)
class ErrorView extends PureComponent {
    static propTypes = {
        staticContext: PropTypes.object,
        userState: PropTypes.object,
        configState: PropTypes.object,
        status: PropTypes.number,
        messages: PropTypes.instanceOf(Immutable.Map).isRequired
    };

    static defaultProps = {
        status: 500
    };

    render() {
        const {messages, status, staticContext, userState, configState} = this.props;

        if (staticContext) {
            staticContext.status = status || 500;
        }

        // make sure status is supported in i18n doc
        const messageCode = SUPPORTED_ERROR_CODES.includes(status) ? status : 500;
        // NOTE: avoid the Message component since this view can be server rendered
        // const title = getMessage(messages, `affiliate.main.error.${messageCode}.title`);
        const message = getMessage(messages, `affiliate.main.error.${messageCode}.message`);
        const btnText = getMessage(messages, 'affiliate.main.error.btn.back');
        // only render character for 404 error

        const {accountInfo} = userState;
        const {epicFooter} = configState;

        return (
            <Fragment>
                <Header messages={messages} accountInfo={accountInfo} configState={configState} />
                <div className={styles.component}>
                    <span className={styles[`charactor${status}`]} />
                    <div className={styles.statusText}>
                        <p>{status}</p>
                    </div>
                    <div className={styles.content}>
                        <div className={styles.messageWrapper}>
                            <p className={styles.messageText}>{message}</p>
                        </div>
                        <div className={styles.backButton}>
                            <Button to="/" theme="dark">
                                {btnText}
                            </Button>
                        </div>
                    </div>
                </div>
                <Footer content={epicFooter} messages={messages} accountInfo={accountInfo} />
            </Fragment>
        );
    }
}
export const ServerErrorView = props => (
    <div className={cx('global', styles.serverError)}>
        <ErrorView {...props} />
    </div>
);
export default connect(mapMessageStateToProps)(ErrorView);
